import {SearchFormProps} from "../../common/searchForm/SearchForm.props";
import {OptionType} from "../../common/searchForm/constants/Option.type";
import {InquiryKeywordTypeList, InquiryTypeList, StatusTypeList} from "./SearchType";

export const InquirySearchFormProps: SearchFormProps = {
    options: [
        {
            type: OptionType.CHECK_LIST,
            key: "type",
            name: "분류",
            list: InquiryTypeList.map(it => it.type),
            stringList: InquiryTypeList.map(it => it.name),
            value: [true, true]
        },
        {
            type: OptionType.CHECK_LIST,
            key: "isCompleted",
            name: "상태",
            list: StatusTypeList.map(it => it.type),
            stringList: StatusTypeList.map(it => it.name),
            value: [true, true]
        },
        {
            type: OptionType.TYPE_TEXT,
            key: "keyword",
            name: "검색",
            list: InquiryKeywordTypeList.map(it => it.type),
            stringList: InquiryKeywordTypeList.map(it => it.name),
            value: {
                type: InquiryKeywordTypeList[0].type,
                text: ""
            }
        }
    ],
    onSearch: () => {},
    onUpdate: () => {}
}